"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowNumericEditor_1 = require("../../../../../../../../shared/components/editors/CardRowNumericEditor");
var TabEditorContainer_1 = require("../../../../../../../../shared/components/containers/TabEditorContainer");
var react_ace_1 = require("react-ace");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var antd_1 = require("antd");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var BrandPayoutEditor = /** @class */ (function (_super) {
    __extends(BrandPayoutEditor, _super);
    function BrandPayoutEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_json_tpl = "json_tpl";
        _this.key_testval = "testval";
        _this.key_gws_tpl = "gws_tpl";
        _this.key_keyvals = "key_keyvals";
        _this.tpl_header_n = "<#assign content = response?eval>\n{\n \"email\":\"${content.user.email},\" \n \"currency\":\"${content.user.currency}\" \n }";
        _this.columns = [
            {
                title: 'Ключ',
                dataIndex: _this.props.listAvailAppPayoutKeyVals.dk_key_val,
                key: _this.props.listAvailAppPayoutKeyVals.dk_key_val,
                width: 200,
            }, {
                title: 'Значение',
                dataIndex: _this.props.listAvailAppPayoutKeyVals.dk_val_val,
                key: _this.props.listAvailAppPayoutKeyVals.dk_val_val,
                align: "center",
                width: 200,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 100
            }
        ];
        return _this;
    }
    BrandPayoutEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_payout_id: _item.app_payout_id,
                    app_payout_title: _item.app_payout_title,
                    is_locked: _item.is_locked,
                    comission_percent_x100: _item.comission_percent_x100,
                    comission_fixed_amount: _item.comission_fixed_amount,
                    min_amount: _item.min_amount,
                    max_amount: _item.max_amount,
                    gateway: _item.gateway,
                    json_tpl: _item.json_tpl,
                    json_tpl_test_data: _item.json_tpl_test_data,
                    account_regex_js: _item.account_regex_js,
                    is_use_account_regex_js: _item.is_use_account_regex_js,
                    account_example: _item.account_example,
                    is_dynamic_gateway: _item.is_dynamic_gateway,
                    gateway_tpl: _item.gateway_tpl,
                    data_keyvals: [],
                    payout_type_code: _item.payout_type_code,
                    payout_type_title: _item.payout_type_title,
                    tabKey: this.key_main
                }, function () {
                    _this.SID = _this.props.listAvailAppPayoutKeyVals.Subscribe("*", function (id, data) {
                        _this.setState({
                            data_keyvals: data.data,
                            totalRows: data.total
                        });
                    });
                    _this.props.listAvailAppPayoutKeyVals.LoadData(_this.props.record.key);
                });
            }
        }
        else {
            this.setState({
                app_payout_id: 0,
                app_payout_title: "",
                is_locked: false,
                comission_percent_x100: 0,
                comission_fixed_amount: 0,
                min_amount: 0,
                max_amount: 0,
                gateway: "",
                json_tpl: this.tpl_header_n,
                json_tpl_test_data: "",
                account_regex_js: "",
                is_use_account_regex_js: false,
                account_example: "",
                is_dynamic_gateway: false,
                gateway_tpl: "",
                data_keyvals: [],
                payout_type_code: 0,
                payout_type_title: "",
                tabKey: this.key_main
            }, function () {
                _this.props.data.DetailsAppPayoutGet(function (testData) {
                    _this.setState({ json_tpl_test_data: testData });
                });
            });
        }
        this.doReSetRules();
    };
    BrandPayoutEditor.prototype.componentWillUnmount = function () {
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.props.listAvailAppPayoutKeyVals.UnSubscribe(this.SID);
            }
        }
    };
    BrandPayoutEditor.prototype.doReSetRules = function () {
        this.setState({
            app_payout_rules: { isError: false },
            account_regex_js_rules: { isError: false },
            payout_type_rules: { isError: false },
        });
    };
    BrandPayoutEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_payout_id <= 0) || (this.state.app_payout_title.length === 0)) {
            this.setState({ app_payout_rules: { isError: true, errorMessage: "Тип выплаты не выбран!" } });
            return false;
        }
        if ((this.state.payout_type_code <= 0) || (this.state.payout_type_title.length === 0)) {
            this.setState({ payout_type_rules: { isError: true, errorMessage: "Тип поля не выбран!" } });
            return false;
        }
        if (this.state.is_use_account_regex_js) {
            if ((!this.state.account_regex_js) || (this.state.account_regex_js.length === 0)) {
                this.setState({ account_regex_js_rules: { isError: true, errorMessage: "Regexp проверки аккаунта не указан!" } });
                return false;
            }
        }
        return true;
    };
    BrandPayoutEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                app_payout_id: this.state.app_payout_id,
                is_locked: this.state.is_locked,
                comission_percent_x100: this.state.comission_percent_x100,
                comission_fixed_amount: this.state.comission_fixed_amount,
                min_amount: this.state.min_amount,
                max_amount: this.state.max_amount,
                gateway: this.state.gateway,
                json_tpl: this.state.json_tpl,
                is_use_account_regex_js: this.state.is_use_account_regex_js,
                account_regex_js: this.state.account_regex_js,
                account_example: this.state.account_example,
                is_dynamic_gateway: this.state.is_dynamic_gateway,
                gateway_tpl: this.state.gateway_tpl,
                payout_type_code: this.state.payout_type_code
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Тип выплаты партнерской программы брэнда изменен!");
            });
        }
    };
    BrandPayoutEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                brand_id: this.props.rootRecord.key,
                app_payout_id: this.state.app_payout_id,
                is_locked: this.state.is_locked,
                comission_percent_x100: this.state.comission_percent_x100,
                comission_fixed_amount: this.state.comission_fixed_amount,
                min_amount: this.state.min_amount,
                max_amount: this.state.max_amount,
                gateway: this.state.gateway,
                json_tpl: this.state.json_tpl,
                is_use_account_regex_js: this.state.is_use_account_regex_js,
                account_regex_js: this.state.account_regex_js,
                account_example: this.state.account_example,
                is_dynamic_gateway: this.state.is_dynamic_gateway,
                gateway_tpl: this.state.gateway_tpl,
                payout_type_code: this.state.payout_type_code
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Тип выплаты партнерской программы брэнда добавлен!");
            });
        }
    };
    BrandPayoutEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandPayoutEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новый тип выплаты партнерской программы брэнда";
        }
        else {
            return "Изменить тип выплаты партнерской программы брэнда";
        }
    };
    BrandPayoutEditor.prototype.getMainContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип выплаты:", placeholder: "Выберите тип выплаты" }, value: { key: this.state.app_payout_id, value: this.state.app_payout_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_payout_id: newVal.key,
                        app_payout_title: newVal.value,
                        app_payout_rules: { isError: false }
                    });
                }, items: this.props.availPayouts, required: true, rules: this.state.app_payout_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "% комиссии", placeholder: "Введите % комиссии" }, values: { max: 99, min: 0, value: this.state.comission_percent_x100 }, onValueChanged: function (newVal) {
                    _this.setState({
                        comission_percent_x100: newVal
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Фикс комиссия", placeholder: "Введите фикс. комиссию" }, values: { max: 999999, min: 0, value: this.state.comission_fixed_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        comission_fixed_amount: newVal
                    });
                }, precision: 2 }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Минимальная сумма", placeholder: "Введите минимальную сумму" }, values: { max: 999999, min: 0, value: this.state.min_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        min_amount: newVal
                    });
                }, precision: 2 }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Максимальная сумма", placeholder: "Введите максимальную сумму" }, values: { max: 999999, min: 0, value: this.state.max_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        max_amount: newVal
                    });
                }, precision: 2 }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Шлюз:", placeholder: "Введите значение шлюза" }, value: this.state.gateway, onValueChanged: function (newVal) { _this.setState({ gateway: newVal }); }, disabled: this.state.is_dynamic_gateway }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Regexp аккаунта:", placeholder: "Введите regexp аккаунта" }, value: this.state.account_regex_js, onValueChanged: function (newVal) { _this.setState({ account_regex_js: newVal }); }, required: this.state.is_use_account_regex_js, disabled: !this.state.is_use_account_regex_js, rules: this.state.account_regex_js_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Использовать regexp", value: this.state.is_use_account_regex_js, onChecked: function (checked) { _this.setState({ is_use_account_regex_js: checked }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Пример аккаунта:", placeholder: "Введите пример аккаунта" }, value: this.state.account_example, onValueChanged: function (newVal) { _this.setState({ account_example: newVal }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип поля ввода:", placeholder: "Выберите тип поля ввода" }, value: { key: this.state.payout_type_code, value: this.state.payout_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        payout_type_code: newVal.key,
                        payout_type_title: newVal.value,
                        payout_type_rules: { isError: false }
                    });
                }, items: this.props.availPayoutTypes, required: true, rules: this.state.payout_type_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Динамический шлюз", value: this.state.is_dynamic_gateway, onChecked: function (checked) { _this.setState({ is_dynamic_gateway: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Выплата заблокирована", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            this.getDownButtons()));
    };
    BrandPayoutEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BrandPayoutEditor.prototype.onChangeJSONTPL = function (newValue) {
        this.setState({ json_tpl: newValue });
    };
    BrandPayoutEditor.prototype.getJsonTplContent = function () {
        return (React.createElement("div", { style: {
                minHeight: "550px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start"
            } },
            React.createElement(react_ace_1.default, { mode: "ftl", theme: "sqlserver", onChange: this.onChangeJSONTPL.bind(this), name: "UNIQUE_ID_OF_RECORD_CONTENT_DIV_FTL", editorProps: { $blockScrolling: true }, width: "100%", height: "460px", fontSize: 14, value: this.state.json_tpl, style: { borderStyle: "solid", borderWidth: "1px", borderColor: "#d9d9d9" } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: {
                    btnEdit: "Сохранить",
                    btnGoBack: "Вернуться",
                    btnFill: "Заполнить",
                    btnPreview: "Просмотр"
                }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this), onFillClick: this.onFillClickTpl.bind(this), onPreviewClick: this.onPreviewJSONClick.bind(this) })));
    };
    BrandPayoutEditor.prototype.onChangeGWSTPL = function (newValue) {
        this.setState({ gateway_tpl: newValue });
    };
    BrandPayoutEditor.prototype.getGwsTplContent = function () {
        return (React.createElement("div", { style: {
                minHeight: "550px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start"
            } },
            React.createElement(react_ace_1.default, { mode: "ftl", theme: "sqlserver", onChange: this.onChangeGWSTPL.bind(this), name: "UNIQUE_ID_OF_RECORD_CONTENT_DIV_FTL1", editorProps: { $blockScrolling: true }, width: "100%", height: "460px", fontSize: 14, value: this.state.gateway_tpl, style: { borderStyle: "solid", borderWidth: "1px", borderColor: "#d9d9d9" } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: {
                    btnEdit: "Сохранить",
                    btnGoBack: "Вернуться",
                    btnFill: "Заполнить",
                    btnPreview: "Просмотр"
                }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this), onFillClick: this.onFillClickTpl.bind(this), onPreviewClick: this.onPreviewGWSClick.bind(this) })));
    };
    BrandPayoutEditor.prototype.onPreviewGWSClick = function () {
        var _this = this;
        this.props.data.DoRenderTPLByTestData(this.state.gateway_tpl, this.state.json_tpl_test_data, function (rendered) {
            _this.props.dialogViewText
                .SetTitle("Просмотр")
                .SetText(rendered)
                .SetOnCloseClick(function () { _this.props.dialogViewText.Close(); })
                .Show();
        });
    };
    BrandPayoutEditor.prototype.onFillClickTpl = function () {
        this.setState({ json_tpl: this.tpl_header_n });
    };
    BrandPayoutEditor.prototype.onFillClickTest = function () {
        var _this = this;
        this.props.data.DetailsAppPayoutGet(function (testData) {
            _this.setState({ json_tpl_test_data: testData });
        });
    };
    BrandPayoutEditor.prototype.onPreviewJSONClick = function () {
        var _this = this;
        this.props.data.DoRenderTPLByTestData(this.state.json_tpl, this.state.json_tpl_test_data, function (rendered) {
            _this.props.dialogViewText
                .SetTitle("Просмотр")
                .SetText(rendered)
                .SetOnCloseClick(function () { _this.props.dialogViewText.Close(); })
                .Show();
        });
    };
    BrandPayoutEditor.prototype.onChangeJSONTestData = function (newValue) {
        this.setState({ json_tpl_test_data: newValue });
    };
    BrandPayoutEditor.prototype.getTestContent = function () {
        return (React.createElement("div", { style: {
                minHeight: "550px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start"
            } },
            React.createElement(react_ace_1.default, { mode: "json", theme: "sqlserver", onChange: this.onChangeJSONTestData.bind(this), name: "UNIQUE_ID_OF_RECORD_CONTENT_DIV_JSON", editorProps: { $blockScrolling: true }, width: "100%", height: "460px", fontSize: 14, value: this.state.json_tpl_test_data, style: { borderStyle: "solid", borderWidth: "1px", borderColor: "#d9d9d9" } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: {
                    btnEdit: "Сохранить",
                    btnGoBack: "Вернуться",
                    btnFill: "Заполнить"
                }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this), onFillClick: this.onFillClickTest.bind(this) })));
    };
    BrandPayoutEditor.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            this.props.listAvailAppPayoutKeyVals.LoadData(this.props.record.key);
        }
        if (action === "create") {
            this.props.dlgKeyValueEditor
                //.SetMessageKey(this.state.)
                //.SetZones(this.state.avail_gws_zones)
                .SetDialogTitle("Добавить ключ-значение")
                //.SetOnNoClick(() => { this.props.dlgKeyValueEditor.Close() })
                .SetOnYesClick(function (keyVal, valVal) {
                _this.props.listAvailAppPayoutKeyVals.AddData({
                    brand_app_payout_id: _this.props.record.key,
                    key_val: keyVal,
                    val_val: valVal
                }, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041A\u043B\u044E\u0447-\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D"));
                });
            })
                .Show();
        }
    };
    BrandPayoutEditor.prototype.onDeleteClick = function (record) {
        this.props.listAvailAppPayoutKeyVals.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041A\u043B\u044E\u0447-\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0431\u044B\u043B\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u043E"));
        });
    };
    BrandPayoutEditor.prototype.getSegmentsEditContent = function () {
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data_keyvals, pagination: {}, scroll: { x: true } })));
    };
    BrandPayoutEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainContent();
        }
        if (this.state.tabKey === this.key_json_tpl) {
            return this.getJsonTplContent();
        }
        if (this.state.tabKey === this.key_gws_tpl) {
            return this.getGwsTplContent();
        }
        if (this.state.tabKey === this.key_testval) {
            return this.getTestContent();
        }
        if (this.state.tabKey === this.key_keyvals) {
            return this.getSegmentsEditContent();
        }
        throw "invalid tabkey -> " + this.state.tabKey;
    };
    BrandPayoutEditor.prototype.getTabs = function () {
        var _ret = [];
        _ret.push({ key: this.key_main, tab: "Основные" });
        _ret.push({ key: this.key_json_tpl, tab: "Шаблон JSON" });
        if (this.state.is_dynamic_gateway) {
            _ret.push({ key: this.key_gws_tpl, tab: "Шаблон шлюза" });
        }
        _ret.push({ key: this.key_testval, tab: "Тестовые данные" });
        if (this.props.record) {
            _ret.push({ key: this.key_keyvals, tab: "Ключ-значение" });
        }
        return _ret;
    };
    BrandPayoutEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 820, activeTabKey: this.state.tabKey, tabs: this.getTabs(), onTabChange: function (key) { _this.setState({ tabKey: key }); } }, this.getContent()));
    };
    return BrandPayoutEditor;
}(React.Component));
exports.default = BrandPayoutEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/payout_pp/BrandPayoutEditor.tsx
// module id = 1770
// module chunks = 0